import { API } from '@aws-amplify/api';

const defaultHeaders = {
  'Content-Type': 'application/json',
};

const defaultInit = {
  headers: defaultHeaders,
};

export const wrapRequest = <T = any>(
  apiMethodapiName: 'get' | 'post' | 'put' | 'head' | 'del' | 'patch',
  apiName: 'geonius' | 'mapbox' | 'atlas' | 'geospatial',
  apiPath: string,
  init: Record<string, unknown> = {}
): Promise<T> => {
  const mergeInit = { ...defaultInit, ...init };
  if (init.headers) {
    mergeInit.headers = { ...defaultHeaders, ...init.headers };
  }

  return API[apiMethodapiName](apiName, apiPath, mergeInit);
};
